import { create } from "zustand";

interface AgentConversationState {
  detailsWidth: number;
  setDetailsWidth: (width: number) => void;
}

export const useAgentConversationStore = create<AgentConversationState>((set) => ({
  detailsWidth: 400,
  setDetailsWidth: (width) => set({ detailsWidth: width }),
}));
